import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "resetPassword-loading"
}
const _hoisted_2 = ["disabled", "placeholder", "value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "status" }

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import Loader from '@pf/vue3/Loader.vue';
import Bubble from '../components/Bubble.vue';
import axios from 'axios';

interface RequestPasswordResetRequest
{
    Email: string;
    Locale?: string;
    App: number;
}



export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const i18n = useI18n();
const { t } = i18n;

const router = useRouter();
const store = useStore();


const usernameInput = ref<HTMLInputElement | null>(null);

const validating = ref(false);
const attemptedReset = ref(false);
const errorMessage = ref<string | null>(null);
const translatedMessage = computed(() => translateErrorMessage(errorMessage.value))

// Special constructie voor tonen vertaling van error zie https://github.com/intlify/vue-i18n-next/issues/1396
function translateErrorMessage(value: string | null | undefined) {
    switch (value) {
        case 'nousername': return computed(_ => t('error.nousername')) 
        case 'tooManyRequests': return computed(_ => t('error.tooManyRequests')) 
        case 'unknown': return computed(_ => t('error.unknown')) 
    }
}


const username = computed<string>(() =>
{
    return store.username.value;
});

const usernameValid = computed<boolean>(() =>
{
    return username.value.trim() != '';
});



onMounted(() =>
{
    document.title = t('title');
    watch(i18n.locale, () => { document.title = t('title'); });

    nextTick(() =>
    {
        usernameInput.value?.focus();
    });
});



function setUsername(event: Event)
{
    const value = (event.target as HTMLInputElement).value;
    store.username.value = value;
};


async function resetPassword()
{
    attemptedReset.value = true;

    if (!usernameValid.value)
    {
        showMessage('nousername');
        return;
    }

    clearMessage();
    validating.value = true;
    try
    {
        const response = await axios.post('/v2/resetpassword/request',
            {
                Email: username.value,
                Locale: i18n.locale.value,
                App: store.app.value
            } as RequestPasswordResetRequest);

        switch (response.status)
        {
            case 200:
                router.push({ name: 'resetPasswordSent' });
                break;

            case 429:
                showMessage('tooManyRequests');
                break;

            default:
                showMessage('unknown');
                break;
        }
    }
    finally
    {
        validating.value = false;
    }
}


function clearMessage()
{
    errorMessage.value = null;
}


function showMessage(value: string)
{
    errorMessage.value = value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Bubble, null, {
    default: _withCtx(() => [
      (validating.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(Loader, { style: 'white' })
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "resetPassword",
            onSubmit: _withModifiers(resetPassword, ["prevent"])
          }, [
            _createElementVNode("input", {
              class: _normalizeClass(["form-control", { error: attemptedReset.value && !usernameValid.value }]),
              id: "username",
              ref_key: "usernameInput",
              ref: usernameInput,
              disabled: validating.value,
              placeholder: _unref(t)('placeholders.username'),
              type: "text",
              value: username.value,
              onInput: setUsername,
              autofocus: "",
              autocomplete: "username"
            }, null, 42, _hoisted_2),
            _createElementVNode("input", {
              type: "submit",
              id: "reset",
              class: "btn",
              value: _unref(t)('submit')
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(translatedMessage.value?.value), 1)
            ])
          ], 32))
    ]),
    _: 1
  }))
}
}

})